goog.provide('el8.appchart.showItemDetail');

goog.require('el8.appchart.dialog.addEditImmunization');
goog.require('el8.appchart.dialog.addEditImmunizationNew');
goog.require('el8.appchart.dialog.displayItem');
goog.require('el8.appchart.dialog.reports');
goog.require('el8.appchart.dialog.rxDownloadFills');
goog.require('el8.appchart.medsHx.main');
goog.require('el8.appservice.notifier');
goog.require('el8.model.identify');

el8.appchart.showItemDetail = function(arg, $elt) {
    // @arg is either an object or a document ID
    if (!arg) { return; }

    // $elt is optional feed elt to center on
    $elt = $elt && $elt.length ? $elt : null;

    var item = (typeof(arg) === 'object') ? arg : el8.ptdata.fetchById(arg);

    if (!item) {
        // This is an unexpected situation!
        el8.uiwidget.alert("Sorry! We cannot find the requested document. It may have been removed.");
        return;
    }

    // Display deleted items in a separate overlay
    if (item.isDeleted && item.isDeleted()) {
        el8.appchart.dialog.displayItem.show(item);

    // Display med orders and dc med orders in meds hx overlay
    } else if (el8.model.identify.isPrescription(item)) {
        el8.appservice.notifier.notify('Displaying medication history...');
        el8.appchart.medsHx.main.show({medOrderId: item.getId()});

    } else if (el8.model.identify.isDiscontinueMedOrder(item)) {
        el8.appservice.notifier.notify('Displaying medication history...');
        el8.appchart.medsHx.main.show({dcMedOrderId: item.getId()});

    // Display reports and imported notes in the report feed
    } else if (el8.model.identify.isReport(item) || el8.model.identify.isOrder(item) ||
              ( (item.is('NonvisitNote') || item.is('VisitNote') ) && item.isImportedNote() )) {
        el8.appservice.notifier.notify('Displaying item in report feed...');
        // Pass in $elt for recentering
        el8.appchart.dialog.reports.show({item: item, $elt: $elt});

    // Document addendums get their associated Document shown
    } else if (item.is('DocumentAddendum')) {
        var doc = item.getReferencedDocument();
        el8.appchart.showItemDetail(doc);

    } else if (item.is('NonvisitNote') || item.is('VisitNote')
                || item.is('Letter') || item.is('LetterReceipt')
                || item.is('MessageThread')) {
        el8.appchart.dialog.displayItem.show(item);

    } else if (item.is('PatientImmunization')) {
        var dlg = el8Globals.FEATURES.IRSubmissions
          ? el8.appchart.dialog.addEditImmunizationNew
          : el8.appchart.dialog.addEditImmunization;
        dlg.show({ ptImmunizationId: item.getId() });

    } else if (item.is('RxHistoryDownloadSummary')) {
        el8.appchart.dialog.rxDownloadFills.show(item);

    } else if (item.is('VitalsCollection')) {
        el8.appchart.dialog.documentVitals.show({vcId: item.getId()});
    }
};


